<template>
  <sui-segment class="log" basic>
    <div ref="list" class="list scrolling" :style="{height: `${height}px`}">
      <div class="no-logs" v-if="!logs.length">
        No records yet.
      </div>
      <div class="days" v-if="logs.length">
        <div class="day" v-for="(dayLogs, dayTitle) in logsByDay" :key="dayTitle">
          <div class="date">{{dayTitle}}</div>
          <LogMessage :message="message" v-for="message in dayLogs" :key="message.id" />
        </div>
      </div>
    </div>
  </sui-segment>
</template>

<script>
  import moment from 'moment'
  import {mapGetters} from 'vuex'
  import groupBy from 'lodash/groupBy'
  import LogMessage from '@/components/LogMessage'
  import utils from '@/utils'
  import api from '@/api'

  export default {
    name: 'TaskLog',
    props: {
      taskId: {
        type: String,
        required: true,
      },
      height: {
        type: Number,
        required: false,
        default: 600,
      },
    },
    components: {
      LogMessage,
    },
    data() {
      return {
        logs: [],
      }
    },
    computed: {
      ...mapGetters(['services']),
      service() {
        return this.services.find(service => service.crons.find(task => task.id === this.taskId))
      },
      logsByDay() {
        return groupBy(this.logs, log => log.dayTitle)
      },
    },
    watch: {
      taskId(id2, id1) {
        if (id2 !== id1) {
          this.isEnd = false
          this.init()
        }
      },
    },
    methods: {
      init() {
        this.search().then(newLogs => {
          this.logs = newLogs
          this.isEnd = true
          this.$nextTick(() => {
            this.$refs.list.scrollTop = this.$refs.list.scrollHeight
          })
        })
      },
      scrollToStart() {
        utils.scrollTo(this.$refs.list, 0)
      },
      scrollToEnd() {
        utils.scrollTo(this.$refs.list, this.$refs.list.scrollHeight - this.$refs.list.offsetHeight)
      },
      search() {
        return api.fetchCronLogs(this.taskId).then(messages => messages.map(formatMessage).reverse()).catch(() => [])
      },
    },
    created() {
      this.init()
    },
    beforeDestroy() {
      this.logs.length = 0
    },
  }

  function formatMessage(message) {
    const day = message.end.substr(0, 10)
    return {
      day,
      dayTitle: moment(day).format('LL'),
      highlighted: false,
      id: message.id,
      info: null,
      isError: !message.success,
      level: null,
      message: message.success ? 'Success' : 'Error',
      stderr: message.stderr,
      stdout: message.stdout,
      time: message.end,
      timeTitle: moment(message.end).format('HH:mm:ss'),
    }
  }
</script>

<style scoped>
  .log {
    position: relative;
    padding: 0!important;
    font-size: .9em;
  }
  .list {
    display: flex;
    flex-direction: column;
    height: 600px;
    overflow-y: scroll;
  }
  .segment .list {
    border: 1px solid #ddd;
  }
  .no-logs {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
  }
  .day {
    /* margin-bottom: 1em; */
  }
  .date {
    position: sticky;
    top: -1px;
    z-index: 1;
    padding: .7em;
    background-color: #fafafa;
    border-bottom: 1px solid #eee;
    text-align: center;
    font-weight: bold;
  }
</style>
